import React from 'react';
import PropTypes from 'prop-types';

import ErrorIcon from '@mui/icons-material/Error';
import { FormLabel } from '@mui/material';

import { capitalize } from '../utils/capitalize';

import form from '../commonStyles/formStyles.module.css';

const IconError = (props) => {
    return (
        <p className={form.inputError}>
            {!props.text ? null : (
                <FormLabel error={true} className={props.text.type === 'warning' && form.inputWarning}>
                    <ErrorIcon fontSize="medium" /> <sup>{capitalize(props.text?.message)}</sup>
                </FormLabel>
            )}
        </p>
    );
};

export default IconError;

IconError.propTypes = {
    text: PropTypes.object
};
